var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-loader",class:{ loading: _vm.loading }},[(!_vm.loaded && !_vm.loading)?_c('img',{staticClass:"image-placeholder",attrs:{"src":_vm.$settings.client.imagePlaceholder}}):_vm._e(),(_vm.loaded)?_c('img',{attrs:{"src":_vm.imageUrl}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }